import ProductIcon from '../../../../../ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "IconRow-root_2E3Hu"
};
export function IconRow({
  productType
}) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/_jsx(ProductIcon, {
      type: productType
    })
  });
}